module.exports = __webpack_public_path__ + "static/c17-73eb839cce9e3305af85f1dcc2722730.jpg";